import _ from "lodash";

import {CustomerService} from "../../customer_step_service";
import {buildDataSteps} from "./mock_account_data";

export class CustomerAccountServiceV2 extends CustomerService {

  _buildSteps(customer) {
    let chargingBankFeeOptions = [], originOfAssetsOptions = [];

    const productsService = this._getStepService('products_selection');
    const depot = productsService.getDepot(true);

    if(depot) {
      const depotType = depot.selected_contract_type;

      chargingBankFeeOptions = _.get(
        productsService.banksDataGrouped,
        [
          depot.bankCompanyId,
          'onboarding_allowed_charging_bank_fees_sources',
          depot.is_online ? depotType.code : 'GENETIC_DEPOT'
        ]);

      originOfAssetsOptions = _.get(productsService.banksDataGrouped, [depot.bankCompanyId, 'onboarding_source_of_funds_choices'])
    }

    return buildDataSteps(chargingBankFeeOptions, originOfAssetsOptions);
  }
}